import { Routes } from "@angular/router";
import { AppPage, Error404Component, LoginFormPage, RegisterComponent } from "jk-service";
import { Sysai85BillComponent } from './sysai85/sysai85BillPkg.component';
import { Syspq80Component } from './syspq80/syspq80.component';
import { Admi10BillComponent } from './admi10/admi10BillPkg.component';
import { Admpi83BillComponent } from './admpi83/admpi83BillPkg.component';
import { ReportviewComponent } from 'jk-advcom';
import { Syspi84BillComponent } from "./syspi84/syspi84BillPkg.component";
//import { Syspq80Component } from './syspq80/syspq80.component';

export * from "./_service_sys";
export * from "./_entity_sys";
export * from "./_edit_sys";

export const sysPages: AppPage[] = [
  { title: '線上說明', url: '/sys/helpviewer', id: 'helpviewer', isCheckPower: false },
  { title: '定時工作建立', url: '/sys/sysai85', id: 'sysai85', isCheckPower: true,  },
  { title: '系統說明建立作業', url: '/sys/syspi84', id: 'syspi84', isCheckPower: true,  },
  { title: '派班查詢', url: '/sys/syspq80', id: 'syspq80', isCheckPower: true, },
  { title: '錯誤網頁', url: '/sys/error404', id: 'error404', isCheckPower: true },
  //{ title: '首頁',    url: '/home',    icon: 'home',    id: 'home', isCheckPower: false, checked: true,    hint: '一切從家開始',  },
  { title: '登入者資料建立', url: '/sys/admi10', id: 'admi10', icon: '', isCheckPower: true,  },
  { title: '個人資料設定', url: '/sys/admpi83', id: 'admpi83', icon: '',    isCheckPower: true,  },
  { title: '報表檢視', url: '/sys/reportview', icon: 'question_answer', id: 'reportview', isCheckPower: false,  },
  { title: 'IP電腦設定記錄', url: '/sys/utyji05', id: 'utyji05', isCheckPower: true },
  { title: '登入', url: '/sys/login-form', id: 'login-form', isCheckPower: false },
];

export const sysRoutes: Routes = [
  {
    path: 'helpviewer',
    loadComponent: () => import('./components/help-viewer/help-viewer.component').then(m => m.HelpViewerComponent),
    data: { preload: false, priority: 3, preloadDelay: 2000 }
  },

  {    path: 'login-form',    component: LoginFormPage,  },
  {   path: 'syspi84',    component: Syspi84BillComponent,  },
  {   path: 'sysai85',    component: Sysai85BillComponent,  },
  {    path: 'syspq80',    component: Syspq80Component,  },
  {    path: 'error404',    component: Error404Component,  },
  {    path: 'admi10',    component: Admi10BillComponent,  },
  {    path: 'admpi83',    component: Admpi83BillComponent,  },
  {    path: 'register',    component: RegisterComponent,  },
  {    path: 'reportview',    component: ReportviewComponent,  },
];


